import parse, { attributesToProps, domToReact } from 'html-react-parser';
import ChartJSChartData from '../../Interfaces/Responses/Reports/Charts/ChartData';
import AgGridJSRowData from '../../Interfaces/Responses/Reports/DataSets/DataSetData';
import ItemIdMap from '../../Interfaces/Reports/ItemIdMap';
import ReportItem from './ReportItem';

interface ParsedReportLayoutProps {
    htmlContent: string;
    items?: ItemIdMap[];
    handleRowClick: (
        dataSetIndex: number,
        index: number,
        rowData: any,
        gridData: AgGridJSRowData
    ) => void | undefined;
    handleBarClick: (
        dataSetIndex: number,
        index: number,
        chartData: ChartJSChartData
    ) => void | undefined;
}

const formatStringToCamelCase = (str: string) => {
    const splitted = str.split("-");
    if (splitted.length === 1) return splitted[0];
    return (
        splitted[0] +
        splitted
            .slice(1)
            .map((word: any) => word[0].toUpperCase() + word.slice(1))
            .join("")
    );
  };
  
export const getStyleObjectFromString = (str = '') => {
    const style: any = {};
    str.split(";").forEach(el => {
        const [property, value] = el.split(":");
        if (!property) return;
    
        const formattedProperty = formatStringToCamelCase(property.trim());
        style[formattedProperty] = value.trim();
    });
  
    return style;
};

const ParsedReportLayout: React.FC<ParsedReportLayoutProps> = ({
    htmlContent,
    items = [],
    handleRowClick,
    handleBarClick,
}) => {
    const replaceWithDiv = (text: string) => {
        const regex = /{(\d+)}/g;
        return text.replace(regex, (match, id) => {
            return `<div class="report-item" data-id="${id}"></div>`;
        });
    };

    let sanitizedHtml = replaceWithDiv(htmlContent);

    const replace = (domNode: any) => {
        if (domNode.attribs) {
            const id = domNode.attribs['data-id'];
            if (domNode.attribs.class && domNode.attribs.class.includes(' card ')) {
                // domNode.attribs.class = domNode.attribs.class.replace(' card ', '');
            }
            const item = items.find((x) => x.id === +id);

            if (item) {
                return (
                    <ReportItem
                        {...item}
                        handleRowClick={handleRowClick}
                        handleBarClick={handleBarClick}
                    />
                );
            }
        }

        // old BI used h3 and h2 in html layouts with custom css,
        // so, we need to treat these as specialty spans
        if (domNode.name === 'h3' || domNode.name === 'h2') {
            const props = attributesToProps(domNode.attribs);
            props.style = { ...(props?.style ?? {}), fontSize: '16px' };
            return <span {...props}>{domToReact(domNode?.children, options)}</span>;
        }

        return null;
    };

    const options = {
        replace
    }

    return (
        <div
            className={`ParsedReportLayout ${items.length === 1 ? 'ParsedReportLayoutSingle' : 'ParsedReportLayoutStacked'}`}
            style={{display: 'flex', justifyContent: 'center', alignContent: 'center'}}
        >
            {parse(sanitizedHtml, options)}
        </div>
    );
};

export default ParsedReportLayout;
